import React from 'react';
import classNames from 'classnames';
import { Loader } from '@fiverr-private/fit';

import { ModalLoaderProps } from '../types';
import styles from './index.module.scss';

const ModalLoader: React.FC<ModalLoaderProps> = ({ children, isLoading = false }) => (
    <div className={styles.container}>
        {isLoading && <div className={classNames(styles.absolute, 'flex-center')} data-testid={'modal-loader'}><Loader/></div>}
        <div className={classNames({ [styles.hidden]: isLoading }, styles.content)}>{children}</div>
    </div>
);

ModalLoader.displayName = 'ModalLoader';

export default ModalLoader;
